import React, { useState, createContext, useEffect } from 'react';
import { useHistory } from 'react-router';

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const [state, setState] = useState({
    isAuth: false,
    token: null,
    userId: null,
    userData: null,
  });
  const history = useHistory();

  const logout = () => {
    setState({ userId: null, isAuth: false, token: null });
    localStorage.removeItem('token');
    localStorage.removeItem('expiryDate');
    localStorage.removeItem('userId');
    localStorage.removeItem('userData');
    history.push('/login');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const autoLogout = (ms) => {
    setTimeout(() => {
      logout();
    }, ms);
  };

  useEffect(() => {
    const autoLogout = (ms) => {
      setTimeout(() => {
        logout();
      }, ms);
    };
    const token = localStorage.getItem('token');
    const expiryDate = localStorage.getItem('expiryDate');
    if (!token || !expiryDate) {
      return;
    }
    if (new Date(expiryDate) <= new Date()) {
      logout();
      return;
    }
    const userId = localStorage.getItem('userId');
    const userData = localStorage.getItem('userData');
    const remainingMilliseconds =
      new Date(expiryDate).getTime() - new Date().getTime();
    setState({ isAuth: true, token, userId, userData });
    autoLogout(remainingMilliseconds);
  }, []);

  const value = {
    state,
    setState,
    autoLogout,
    logout,
  };
  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
};

export default AuthContextProvider;
